/* Product-scoped presentation adapter. Shopify's native variant fetch handles price, stock, gallery and cart IDs. */
(() => {
  const types = ['Booties', 'Headband', 'Hat'];
  const sets = {0:'Romper Only',1:'Romper + Booties',2:'Romper + HeadBand',3:'Romper+Booties+Hband',4:'Romper + Hat',5:'Romper +Booties +Hat',7:'All Four Set'};
  const colorOf = value => /ap[ir]+c?ote|apricot/i.test(value) ? 'Apricot' : /grayish/i.test(value) ? 'Grayish Blue' : /kha[ik]+i?/i.test(value) ? 'Khaki' : /pink/i.test(value) ? 'Pink' : /rose/i.test(value) ? 'Rose' : 'White';
  async function init(root) {
    if (root.dataset.ready) return;
    const picker = document.getElementById(root.dataset.picker);
    if (!picker) return;
    await customElements.whenDefined('variant-selects');
    const groups = () => [...picker.querySelectorAll('fieldset')];
    if (groups().length !== 3) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-gg-romper-config]').textContent);
    const colors = config.colors;
    const addonColors = config.addonColors || [];
    const deepLinked = new URL(location.href).searchParams.has('variant');
    const current = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const state = {size:current.option1,style:/ruff/i.test(current.option3)?'Ruffle':'Classic',color:colorOf(current.option3),addons:{}};
    const setMask = Object.keys(sets).find(key => sets[key] === current.option2);
    types.forEach((type,index) => {if (deepLinked && ((Number(setMask)||0) & (1<<index))) state.addons[type] = state.color;});
    let busy = false, invalid = false, failed = false;
    function syncPurchaseButton() {
      const button=document.getElementById(root.dataset.form)?.querySelector('[name="add"]');
      if(!button)return;
      const pending=busy||invalid||failed;
      const label=busy?'Updating your selection…':invalid||failed?'Select the options above':picker.currentVariant?.available===false?'Sold out':'Add to Cart';
      button.dataset.ggPurchasePending=String(pending);
      button.setAttribute('aria-busy',String(busy));
      button.querySelectorAll('.btn__texts__item').forEach(item=>item.textContent=label);
      if(pending)button.disabled=true;
    }
    function tile(text, parent, selected, action, image, cell, accessible, single=false) {
      const b = document.createElement('button'); b.type='button'; b.setAttribute('aria-pressed',String(selected));
      b.disabled=busy; b.onclick=action;
      if (accessible) b.setAttribute('aria-label',accessible);
      if (image) {
        b.className='gg-ro-tile';const box=document.createElement('span');box.className=single?'gg-ro-image gg-ro-single':'gg-ro-image';
        box.style.setProperty('--ro-x',`${-(cell%3)*100}%`);box.style.setProperty('--ro-y',`${-Math.floor(cell/3)*100}%`);
        const img=document.createElement('img');img.src=image;img.alt='';img.width=single?1024:1536;img.height=1024;img.loading='lazy';img.decoding='async';
        // Pink's sheet has wider white margins. Normalize each item's visible size
        // around its own cell center without moving the crop into a neighboring cell.
        if(!single&&text==='Pink'&&cell>=2){
          img.style.transform=`scale(${[1.2,1.43,1.35,1.24,1.42][cell]})`;
          img.style.transformOrigin=`${((cell%3)+.5)/3*100}% ${(Math.floor(cell/3)+.5)/2*100}%`;
        }
        box.append(img);b.append(box);
      }
      const label=document.createElement('span');label.textContent=text;b.append(label);parent.append(b);return b;
    }
    function render() {
      root.setAttribute('aria-busy',String(busy));
      const sizeBox=root.querySelector('[data-ro-sizes]');sizeBox.replaceChildren();
      const sizes=[...groups()[0].querySelectorAll('input[type=radio]')].map(x=>x.value);
      ['Newborn','0-3M','3-6M','6-12M','12-18M'].filter(x=>sizes.includes(x)).forEach(value=>tile(value,sizeBox,state.size===value,()=>change(0,value)));
      const styleBox=root.querySelector('[data-ro-styles]');styleBox.replaceChildren();
      ['Classic','Ruffle'].forEach(value=>tile(value,styleBox,state.style===value,()=>changeGarment(value,state.color)));
      const colorBox=root.querySelector('[data-ro-colors]');colorBox.replaceChildren();
      colors.forEach(color=>{const image=color.images?.[state.style.toLowerCase()];tile(color.name,colorBox,state.color===color.name,()=>changeGarment(state.style,color.name),image||color.garmentImage||color.image,state.style==='Classic'?0:1,`${state.style} ${color.name}`,!!image);});
      const addonBox=root.querySelector('[data-ro-addons]');addonBox.replaceChildren();
      types.forEach((type,index)=>{
        const wrap=document.createElement('div');wrap.className='gg-ro-addon';
        const label=document.createElement('label');label.className='gg-ro-toggle';
        const input=document.createElement('input');input.type='checkbox';input.checked=!!state.addons[type];input.disabled=busy;
        input.onchange=()=>{if(input.checked)state.addons[type]=state.color;else delete state.addons[type];changeSet();};
        label.append(input,document.createTextNode(`${type} (+$5)` ));wrap.append(label);
        const grid=document.createElement('div');grid.className='gg-ro-grid';grid.hidden=!state.addons[type];
        grid.setAttribute('role','group');grid.setAttribute('aria-label',`${type} color`);
        [...colors,...addonColors.filter(color=>color.images?.[type.toLowerCase()])].forEach(color=>{const image=color.images?.[type.toLowerCase()];tile(color.name,grid,state.addons[type]===color.name,()=>{state.addons[type]=color.name;render();},image||color.image,index+2,`${type} ${color.name}`,!!image);});
        wrap.append(grid);addonBox.append(wrap);
      });
      const error=root.querySelector('[data-ro-error]');error.hidden=!invalid;error.textContent=invalid?'Headband + Hat is available in the complete set with Booties. Add Booties or remove one accessory.':'';
      root.querySelector('[data-ro-summary]').textContent=[state.size,`${state.style} · ${state.color}`,...types.filter(x=>state.addons[x]).map(x=>`${x} · ${state.addons[x]}`)].join(' / ');
      const properties=root.querySelector('[data-ro-properties]');properties.replaceChildren();
      const values={'Style Romper & Color':`${state.style} - ${state.color}`};types.forEach(type=>{if(state.addons[type])values[`${type} color`]=state.addons[type];});
      Object.entries(values).forEach(([name,value])=>{const input=document.createElement('input');input.type='hidden';input.name=`properties[${name}]`;input.value=value;input.setAttribute('form',root.dataset.form);properties.append(input);});
      syncPurchaseButton();
    }
    async function choose(index,value) {
      const input=[...groups()[index].querySelectorAll('input[type=radio]')].find(x=>x.value===value);
      if(!input?.dataset.variantId)throw Error('This combination is unavailable. Please choose another option.');
      input.checked=true;
      await picker.onVariantChange({target:input});
      const selected=JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
      if(selected[`option${index+1}`]!==value)throw Error('Could not update this selection. Please try again.');
      return selected;
    }
    async function change(index,value) {
      if(busy)return;
      failed=false;busy=true;render();
      try {
        const selected=await choose(index,value);
        state.size=selected.option1;state.color=colorOf(selected.option3);state.style=/ruff/i.test(selected.option3)?'Ruffle':'Classic';
      } catch(error) {
        const message=root.querySelector('[data-ro-error]');message.textContent=error.message;message.hidden=false;
        busy=false;failed=true;root.setAttribute('aria-busy','false');root.querySelectorAll('button,input[type=checkbox]').forEach(b=>b.disabled=false);
        picker.toggleAddButton(true);syncPurchaseButton();return;
      }
      busy=false;render();if(!invalid)picker.toggleAddButton(!picker.currentVariant?.available);syncPurchaseButton();
    }
    function changeGarment(style,color) {
      const value=[...groups()[2].querySelectorAll('input[type=radio]')].find(x=>colorOf(x.value)===color&&(/ruff/i.test(x.value)?'Ruffle':'Classic')===style)?.value;
      if(value)change(2,value);
    }
    function changeSet() {
      const mask=types.reduce((value,type,index)=>value+(state.addons[type]?(1<<index):0),0);
      invalid=mask===6;
      if(invalid){render();return;}
      change(1,sets[mask]);
    }
    // Variant updates replace the native form; validate through a stable delegated listener.
    const nameField=()=>document.querySelector(`[name="properties[Embroidered name]"][form="${root.dataset.form}"]`);
    document.addEventListener('input',event=>{
      if(event.target===nameField()){event.target.setCustomValidity('');event.target.removeAttribute('aria-invalid');}
    });
    document.addEventListener('submit',event=>{
      if(event.target.id!==root.dataset.form)return;
      if(invalid||busy){event.preventDefault();event.stopImmediatePropagation();return;}
      const name=nameField();
      if(name&&!name.value.trim()){
        event.preventDefault();event.stopImmediatePropagation();
        name.setCustomValidity('Please enter the name you would like embroidered.');
        name.setAttribute('aria-invalid','true');name.reportValidity();name.focus();
      }
    },true);
    root.hidden=false;root.parentElement.classList.add('gg-ro-ready');render();
    // A hat-only URL must not silently purchase a hat while the UI displays a romper.
    if(setMask===undefined||!deepLinked)await change(1,sets[0]);
    else await change(0,state.size);
  }
  document.querySelectorAll('[data-gg-romper-options]').forEach(init);
})();
